import { render } from "./hostPath.vue?vue&type=template&id=362c104c"
import script from "./hostPath.vue?vue&type=script&lang=js"
export * from "./hostPath.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__